import Vue from 'vue'
import Store from '@/store'
/**
 * Created by jiachenpan on 16/11/18.
 */

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

export function closeTooltip(vueComp) {
  vueComp.$children.map(comp => {
    if (comp.$refs.tooltip) {
      comp.$refs.tooltip.hide()
    }
    closeTooltip(comp)
  })
}
export const reLogin = isOrigin => {
  if (window.__POWERED_BY_QIANKUN__) {
    Vue.prototype.mainProps.relogin()
    return
  }
  // Vue.ls.set('pathname', window.location.pathname !== '/login' ? window.location.pathname + window.location.search + window.location.hash : '')
  const config = Store.getters.domain
  const loginUrl = config.LOGIN_URL
  const clientId = config.CLIENT_ID.USERCENTER
  const redirectUri = window.location.origin + '/login'
  window.location.href = `${loginUrl}?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=openid`
}
export function searchToObj(str) {
  const obj = {}
  if (str === undefined) {
    return obj
  }
  str = str.substr(1)
  const arr = str.split('&')
  let newArr = []
  arr.map(function(value, index, arr) {
    newArr = value.split('=')
    if (newArr[0] !== undefined) {
      obj[newArr[0]] = newArr[1]
    }
  })
  return obj
}


// 获取百度开发者key
export function getBaiduKey() {
  if (window.location.host.indexOf('.chery.cn') > -1) {
    // 奇瑞官方key
    return '46OtTUptHyZ6AkCDvGTWN60n3o3goK0w'
  } else {
    // 数跑内部key
    return 'l1YjSCGvL4sHZX1IqdBiVBiLGl2tTeTT'
  }
}

// 防抖
export function _debounce(fn, delayInit) {
  const delay = delayInit || 200
  var timer
  return function() {
    var th = this
    var args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function() {
      timer = null
      fn.apply(th, args)
    }, delay)
  }
}
// 节流
export function _throttle(fn, intervalInit) {
  var last
  var timer
  const interval = intervalInit || 200
  return function() {
    var th = this
    var args = arguments
    var now = +new Date()
    if (last && now - last < interval) {
      clearTimeout(timer)
      timer = setTimeout(function() {
        last = now
        fn.apply(th, args)
      }, interval)
    } else {
      last = now
      fn.apply(th, args)
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/index.js